<template>
  <div>
    <surveys-table
      surveyName="ADCT"
      surveyCode="ADCT"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_ADCT,
        viewDetail: permissions.SEE_DETAIL_SURVEY_ADCT,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
